import * as React from "react";
export const SuccessHeader: React.FC = () => {
  return (
    <header className="flex flex-col items-center w-full">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/7951366160e541d0bb67ff4b832b0c72/dc41759376d9947110922090cdea348f25f7898b?placeholderIfAbsent=true"
        alt="Logo"
        className="object-contain w-[260px]"
      />
      <h1 className="mt-36 text-6xl font-bold text-center text-white max-md:mt-20 max-md:text-3xl">
        <span className="text-[#25F4EE]">Success! </span><br />
        You've built your own avatar recap.
      </h1>
      <div className="font-normal text-[20px] leading-[32px] text-[#25F4EE] mt-5 text-center">
        Here is your final generated avatar
      </div>
    </header>
  );
};